import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[translationMediaDetailDirective]',
})
export class TranslationMediaDetailDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}